import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const EditDomain = () => {
  const { pubId, domainId } = useParams(); // Get domain ID from URL
  const navigate = useNavigate();
  const [domainData, setDomainData] = useState({
    name: "",
    domain: "",
    account_id: "",
    site_id: "",
    status: "",
  });

  // Fetch domain details
    const fetchDomain = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getSiteInfo/${pubId}/${domainId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (response.status === 200 && response.data?.data?.length > 0) {
          const siteData = response.data.data[0];
            console.log(response);            
          setDomainData({
            name: siteData.name,
            domain: siteData.domain,
            account_id: siteData.account_id,
            site_id: siteData.id,
            status: siteData.status,
          });
        }
      } catch (error) {
        console.error("Error fetching domain details:", error);
      }
    };
    useEffect(() => {
    fetchDomain();
    console.log(domainData);    
  }, [pubId, domainId]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      debugger;
      const token = localStorage.getItem("token");
      const requestData = {
        account_id: domainData.account_id,
        site_id: domainData.site_id,
        status: domainData.status,
        name: domainData.name,
        domain: domainData.domain,
      };
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/updateSiteInfo`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        alert("Domain updated successfully!");
        navigate(`/domain-list/${pubId}`);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
      console.error("Error updating domain:", error);
    }
  };

  return (
    <section className="mainContainer">
      <div className="container mt-4">
        <h2>Edit Domain</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              value={domainData.name}
              onChange={(e) => setDomainData({ ...domainData, name: e.target.value })}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Domain</label>
            <input
              type="text"
              className="form-control"
              value={domainData.domain}
              onChange={(e) => setDomainData({ ...domainData, domain: e.target.value })}
              required
            />
          </div>

          <button type="submit" className="btn btn-success">
            Save Changes
          </button>
          <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>
            Cancel
          </button>
        </form>
      </div>
    </section>
  );
};

export default EditDomain;
